import React from 'react';
import '../CSS/CurrentIssue.css';

const CurrentIssue = () => {
    return (
        <div className="current-issue-container">
            <div className="current-issue-content">
                <h1 className="page-title">Current Issue</h1>
                <div className="issue-details">
                    <h2>Innovative Trends in Multidisciplinary Engineering (ITME)</h2>
                    <p className="issue-info">Volume I, Issue II | July 2026 Issue</p>
                </div>
                
                <div className="call-for-papers-section">
                    <h3>AI-Enabled Engineering Systems for Healthcare & Life Sciences</h3>
                    <div className="issue-description">
                        <p>
                            This issue focuses on rigorously validated, system-oriented research at the intersection of Artificial Intelligence, advanced engineering architectures, and translational healthcare innovation.
                        </p>
                        <p>
                            As healthcare shifts toward intelligent, data-driven ecosystems, scalable AI-driven engineering frameworks are essential for precision diagnostics, biomedical analytics, smart medical devices, and resilient digital health systems.
                        </p>

                        <h4>Core Focus Areas</h4>
                        <ul>
                            <li>Algorithmic innovation with experimental validation</li>
                            <li>Scalable healthcare data architectures</li>
                            <li>AI integration in cyber-physical medical systems</li>
                            <li>Cross-layer optimization (device–edge–cloud)</li>
                            <li>Secure, ethical, and explainable AI in regulated settings</li>
                        </ul>
                        <p>Submissions must demonstrate methodological rigor, quantitative evaluation, and real-world applicability.</p>

                        <h4>Research Domains</h4>
                        <ul>
                            <li><strong>AI in healthcare:</strong> medical imaging, diagnostics, clinical decision systems, disease prediction, XAI</li>
                            <li><strong>Biomedical engineering:</strong> signal processing, wearable AI, smart devices, cyber-physical systems</li>
                            <li><strong>Digital health infrastructure:</strong> IoT, edge/fog/cloud computing, secure data systems</li>
                            <li><strong>Ethical &amp; sustainable engineering:</strong> responsible AI, regulatory compliance, energy-efficient systems</li>
                        </ul>

                        <h4>Strategic Alignment</h4>
                        <p>Aligned with:</p>
                        <ul>
                            <li>UN SDG 3 – Good Health &amp; Well-Being</li>
                            <li>UN SDG 9 – Industry, Innovation &amp; Infrastructure</li>
                        </ul>
                        <p>The issue promotes healthcare systems that are accessible, scalable, secure, energy-efficient, and ethically responsible.</p>

                        <h4>Expected Contribution</h4>
                        <p>Manuscripts should:</p>
                        <ul>
                            <li>Offer novel engineering contributions</li>
                            <li>Provide reproducible validation and benchmarks</li>
                            <li>Address system-level design challenges</li>
                            <li>Bridge AI research with practical healthcare deployment</li>
                        </ul>
                        <p>Interdisciplinary work integrating computational intelligence with real-world healthcare systems is strongly encouraged.</p>
                    </div>
                    <div className="call-for-papers-image-container">
                        <img 
                            src="/ITME_Call_for_Papers.jpeg" 
                            alt="ITME Call for Papers - July 2026 Issue" 
                            className="call-for-papers-image"
                            onError={(e) => {
                                e.currentTarget.style.display = 'none';
                                e.currentTarget.nextSibling.style.display = 'block';
                            }}
                        />
                        <div className="image-fallback" style={{ display: 'none' }}>
                            <p>Call for Papers image not available. Please contact the editorial office.</p>
                        </div>
                    </div>
                    
                    <div className="download-section">
                        <p>
                            <a 
                                href="/ITME_Call_for_Papers.pdf" 
                                className="download-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                📄 Download Call for Papers (PDF)
                            </a>
                        </p>
                    </div>
                </div>

                <div className="submission-info">
                    <h3>Important Dates</h3>
                    <ul>
                        <li><strong>Abstract Submission Deadline:</strong> 30th March, 2026</li>
                        <li><strong>Notification of Abstract Acceptance:</strong> 10th April, 2026</li>
                        <li><strong>Full Paper Submission Deadline:</strong> 10th May, 2026</li>
                        <li><strong>Notification of Paper Acceptance:</strong> 20th May, 2026</li>
                    </ul>
                </div>

                <div className="contact-section">
                    <h3>Submission</h3>
                    <p>
                        Submit your manuscript through our <a href="/form" className="submission-link">online submission system</a> or 
                        email directly to <a href="mailto:editor.itme@krmangalam.edu.in" className="email-link">editor.itme@krmangalam.edu.in</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CurrentIssue;
